import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'sc-request-loader-fragment',
  templateUrl: './request-loader.fragment.html',
  styleUrls: ['./request-loader.fragment.css']
})
export class RequestLoaderFragment implements OnInit {
  constructor() {}
  public ngOnInit(): void {}
}
